var map = {
	"./barrier.png": "5a2f",
	"./change.png": "cde8",
	"./data.png": "fc19",
	"./event.png": "b973",
	"./human-factor.png": "9e77",
	"./logo.png": "cf05",
	"./man.png": "d378"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";